if (typeof jQuery.migrateMute === 'undefined') {
  jQuery.migrateMute = !window.debug
}
